import { Injectable } from '@angular/core';
import { catchError, EMPTY, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../core/services/api.service';
import { truncateUUID } from '../../core/utils/utils';

export interface IUserActivityTrackPayload {
	type: string;
	text: string;
	link?: string | null;
	company_uuid?: string | null;
}

@Injectable({
	providedIn: 'root',
})
export class UserActivityTrackerService extends ApiService {
	public track(payload: IUserActivityTrackPayload | null | undefined): void {
		if (!payload?.type || !payload?.text) {
			return;
		}

		this.http
			.post(environment.apiUrl + '/user-activity', payload, {
				headers: this.getHeaders(),
			})
			.pipe(
				take(1),
				catchError(() => EMPTY),
			)
			.subscribe();
	}

	public buildLink(path: string, reference?: string | null): string {
		const normalizedPath = path.startsWith('/') ? path : `/${path}`;
		if (!reference) {
			return normalizedPath;
		}

		const params = new URLSearchParams({
			activity_label: reference,
		});

		return `${normalizedPath}?${params.toString()}`;
	}

	public shortReference(value?: string | null, startLength: number = 4, endLength: number = 2): string {
		if (!value) {
			return '';
		}

		return truncateUUID(value, startLength, endLength);
	}
}
